import { render } from "./CodeEditor.vue?vue&type=template&id=00ff3c0a&scoped=true"
import script from "./CodeEditor.vue?vue&type=script&lang=js"
export * from "./CodeEditor.vue?vue&type=script&lang=js"

import "./CodeEditor.vue?vue&type=style&index=0&id=00ff3c0a&lang=scss&scoped=true"
import "./CodeEditor.vue?vue&type=style&index=1&id=00ff3c0a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00ff3c0a"]])

export default __exports__